<script setup lang="ts">
import { CtButton } from '@camelot/components'
import { translate } from '~/composables/translate/translations'
import { LTCS_WEBVIEW_STEPS, navigateToLtcsStep } from '~/composables/utils/navigate-utils'

const { variant, changeDatesTo } = defineProps<{
  variant: 'no-offers' | 'error'
  // Route the "Change dates" CTA navigates to. Defaults to the LTCS date step
  // (old 4-step flow); v3 passes its own /v3/date path.
  changeDatesTo?: string
}>()

const router = useRouter()
const imageURL = useRuntimeConfig().public.imageURL

const content = computed(() => variant === 'no-offers'
  ? {
      image: `${imageURL}/error/no-car.svg`,
      title: translate('webview_no_offers_title'),
      description: translate('webview_no_offers_description'),
      cta: translate('webview_no_offers_cta'),
    }
  : {
      image: `${imageURL}/error/ooops.svg`,
      title: translate('webview_offer_error_title'),
      description: translate('webview_offer_error_description'),
      cta: undefined,
    },
)

function onChangeDates() {
  router.push(changeDatesTo ?? navigateToLtcsStep(LTCS_WEBVIEW_STEPS.DATE))
}
</script>

<template>
  <div class="flex flex-col items-center text-center px-24 pt-40">
    <img class="mx-auto mb-20" :src="content.image" :alt="content.title">
    <h3 class="mb-8">
      {{ content.title }}
    </h3>
    <p class="text-md mb-24">
      {{ content.description }}
    </p>
    <CtButton
      v-if="content.cta"
      variant="primary"
      size="md"
      class="w-full"
      @click="onChangeDates"
    >
      {{ content.cta }}
    </CtButton>
  </div>
</template>

<style scoped lang="scss">
@import "tailwindcss" reference;
@import "@camelot/tailwind-config/themes/camelot.css" reference;
</style>
